var Request = require('../../helper/request');

function State(app, userId, notificationId){
	var self = this;
	self.userId = userId;
	self.notificationId = notificationId;
	self.app = app;
	self.request = new Request(app);

	self.routes = {
		create: {
			url: "/iam/user/"+self.userId+"/notification/"+self.notificationId+"/state",
			method: "POST"
		}
	};
}

/**
	Data: {
		state: "viewed" | "clicked"
	}
*/
State.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		state: data
	});
}

module.exports = State;